import { ENTITY_LABELS } from "../../utils/labelMapping";
import { useContext, useEffect, useState } from "react";

import Header from "./Header";
import Sentiment from "./Sentiment/Sentiment";

import classes from "./set.module.css";
import Modal from "../../Component/Modal/Modal";
import { useDispatch, useSelector } from "react-redux";
import { AuthContext } from "../../context/auth-context";
import AddSet, { AddEditAttribute } from "./AddSet";
import {
  createAttribute,
  createUserSet,
  deleteMetricSetting,
  fetchuserSet,
  fetchShareUsers,
  updateUserSet,
  updatingAttribute,
} from "../../redux/actions/userSentimentActions";
import Spinner from "../../Component/Spinner/Spinner";
import { toast, ToastContainer } from "react-toastify";
import MUIIconButton from "../../Component/UI/MUIIconButton/MUIIconButton";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import ShareModal from "../../Component/ShareModal/ShareModal";

import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ConfirmModal from "../../Component/ConfirmModal";
import { SET_USERSET } from "../../redux/constants/actionTypes";
import {
  Checkbox,
  FormControlLabel,
  FormControl,
  Radio,
  RadioGroup,
  selectClasses,
  Switch,
  Tooltip,
} from "@mui/material";
import MUIButton from "../../Component/UI/MUIButton/MUIButton";
import { upperCaseConverter } from "../../utils/helpers";
import { MessageModal } from "../../Component/ConfirmTemplateModal";
import { DefaultSet } from "../../utils/constant";
export let standardTemplate = "Standard Template";
// export let sentimentQuestionReplacement = "brand/product"
export let sentimentQuestionReplacement = `${ENTITY_LABELS.brand.toLowerCase()}/${ENTITY_LABELS.product.toLowerCase()}`
/*
selected Side template is matricSettingId and intial we assign  isDefault template as selected template
*/


export let requiredCount = {
  visibility: {
    maxCount: 1,
  },
  competitor_rank: {
    maxCount: 1,
  },
  "propensity-visibility": { maxCount: 1 },
  categoryDimension: {
    maxCount: 5
  }
};

export function getTitleName() {
  return {
    sentiment: "Sentiment Question",
    "non-branded-questions": "Open Ended Question",
    "fact-based-questions": "Fact Based Question",
    "propensity-to-buy": "Purchase Intent Question",
    categoryDimension: ENTITY_LABELS.purchaseCriteria,
    "core-attribute": ENTITY_LABELS.brandPillar,
    visibility: `${ENTITY_LABELS.rank} Prompt`,
    competitor_rank: `${ENTITY_LABELS.rank} Prompt (Competitor Set)`,
    "propensity-visibility": `Purchase Intent ${ENTITY_LABELS.rank} Promp`,
    taxonomy: ENTITY_LABELS.productDimension,
  };
}

const SHARE_TEMPLATE_ENDPOINT = "/userset/share/template";
const buildTemplateSharePayload = (template, targets) => ({
  template_id: template.id,
  template_name: template.name,
  targets,
});



const TOP_TAB_OPTIONS = [{ name: standardTemplate, value: DefaultSet }];
export default function SetCreation() {
  const TitleName = getTitleName();
  const { user, customerUiInfo } = useContext(AuthContext);
  const TAB_OPTIONS = [
  {
    name: ENTITY_LABELS.rank,
    value: "rank",
    subTemplates: [
      { name: user?.is_custom_rank ? "By Category" : ENTITY_LABELS.rank, value: "visibility" },
      ...(user?.is_custom_rank ? [{ name: "By Competitor Set", value: "competitor_rank" }] : []),
      // { name: "Purchase Intent Rank", value: "propensity-visibility" }
    ]
  },
  {
    name: "Questions",
    value: "questions",
    subTemplates: [
      { name: "Sentiment", value: "sentiment" },
      ...(customerUiInfo?.is_non_branded_questions
        ? [
            { name: "Open Ended Questions", value: "non-branded-questions" },
            { name: "Fact Based Questions", value: "fact-based-questions" },
          ]
        : []),
      // { name: "Purchase Intent", value: "propensity-to-buy" }
    ]
  },

  {
    name: ENTITY_LABELS.brandPillar,
    value: "core-attribute",
  },
  {
    name: ENTITY_LABELS.purchaseCriteria,
    value: "categoryDimension",
  },
];
  const dispatch = useDispatch();
  const [selectedMainTab, setSelectedMainTab] = useState("rank");
  const [selectedTab, setSelectedTab] = useState("visibility");
  const [isModalOpen, setModalOpen] = useState(false);
  const [showAddModal, setShowAddModal] = useState();
  const [updateAttribute, setUpdateAttribute] = useState(null);
  const [updateMetric, setUpdateMetric] = useState(null);
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [shareTarget, setShareTarget] = useState(null); // { id, name } of the template being shared
  let key = `${TitleName[selectedTab]}`;

  const customer_id = user?.customer_id;
  const user_id = user?.user_role?.user_id;
  const { customIndexScoreTypes } = customerUiInfo || {};
  // Customer-level flag only — whether this customer has a custom index
  // score type configured at all (e.g. "Accessibility"). This drives the
  // Factor field and the visibility add-limit below; it does NOT filter
  // the template list — every template (including Standard) stays listed.
  const hasCustomIndexScoreTypesFeature =
    Array.isArray(customIndexScoreTypes) && customIndexScoreTypes.length > 0;

  const userMetricSetting = useSelector((store) => store.userSet);
  const sideTabOptions = userMetricSetting?.data.length
    ? userMetricSetting.data.map((ele) => {
      return {
        name: ele.name,
        value: ele.id,
        id: ele.id,
        isDefault: ele.isDefault,
      };
    })
    : TOP_TAB_OPTIONS;

  const selectedSideTab = userMetricSetting.metricSettingId;

  const sideTabName =
    sideTabOptions?.find((ele) => {
      return ele.value == selectedSideTab;
    })?.name ?? "";

  // Purchase Criteria isn't applicable for customers with a custom index score type
  const visibleTabOptions = TAB_OPTIONS.filter(
    (opt) => !(hasCustomIndexScoreTypesFeature && opt.value === "categoryDimension")
  );

  // If the tab we're on becomes hidden (e.g. after this customer's flag loads),
  // fall back to the first available main tab
  useEffect(() => {
    if (hasCustomIndexScoreTypesFeature && selectedMainTab === "categoryDimension") {
      const fallback = visibleTabOptions[0];
      if (fallback) {
        setSelectedMainTab(fallback.value);
        setSelectedTab(fallback.subTemplates?.[0]?.value ?? fallback.value);
      }
    }
  }, [hasCustomIndexScoreTypesFeature, selectedMainTab]);

  const handleOpenModal = (type) => {
    setModalOpen(true);
  };

  /*clean up Action*/
  useEffect(() => {
    if (customer_id) {
      dispatch(fetchuserSet({ customer_id, user_id }));
      if (user?.is_sharing_enabled) {
        dispatch(fetchShareUsers());
      }
    }

    return () => {
      dispatch({ type: "RESET_METRIC" });
    };
  }, [customer_id, user?.is_sharing_enabled]);

  const handleShareClick = (option) => {
    setShareTarget({ id: option.id ?? option.value, name: option.name });
    setShareModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setUpdateMetric(null);
  };

  const handleCloseAddModal = () => {
    setShowAddModal(false);
    setUpdateAttribute(null);
  };

  // Metric Save
  const handleSave = ({ name, template, id, isDefault, customIndexScoreType }) => {
    let data = sideTabOptions?.find((ele) => ele.value == template);
    if (!id) {
      dispatch(
        createUserSet({
          customer_id,
          user_id,
          MetricSettingId: data?.value ?? null,
          name,
          isDefault,
          ...(customIndexScoreType ? { customIndexScoreType } : {}),
        })
      );
    } else {
      dispatch(
        updateUserSet({
          id,
          name,
          user_id,
          customer_id,
          isDefault,
        })
      );
    }
    handleCloseModal();
  };

  const setDefault = ({ id, isDefault, name }) => {
    dispatch(
      updateUserSet({
        id,
        name,
        user_id,
        customer_id,
        isDefault,
      })
    );
  };
  //Attribute save like sentiment
  const handleAttributeSave = ({ attribute, template, id, definition, factor }) => {
    let data = sideTabOptions?.find((ele) => ele.value == template);
    /*we creating new attribute*/
    if (!updateAttribute) {
      dispatch(
        createAttribute({
          customer_id,
          user_id,
          MetricSettingId: data?.value ?? null,
          attribute,
          type: selectedTab,
          definition,
          factor,
          key,

        })
      )
        .then((attributeObj) => {
          dispatch({
            type: "HANDLE_ATTRIBUTE_CREATE",
            payload: {
              attributeObj,
              type: selectedTab,
              selectedSideTab: attributeObj.setting_Id,
            },
          });
        })
        .catch((err) => {
          console.log(`Fail to add ${selectedTab}`, err.message);
        });
    } else {
      /*updating existing attribute */
      dispatch(
        updatingAttribute({
          attribute,
          id,
          definition,
          factor,
          type: selectedTab,
          key,
        })
      )
        .then((attributeObj) => {
          dispatch({
            type: "HANDLE_ATTRIBUTE_UPDATE",
            payload: {
              attributeObj,
              type: selectedTab,
              selectedSideTab: attributeObj.setting_Id,
            },
          });
        })
        .catch((err) => {
          console.log(`Fail to add ${selectedTab}`, err.message);
        });
    }

    handleCloseAddModal();
  };

  //on edit icon click of sentiment question

  function editIconClick(item) {
    setShowAddModal(true);
    setUpdateAttribute(item);
  }

  //
  async function handleMetricSettingDelete(deleteSetting) {
    await dispatch(deleteMetricSetting({ id: deleteSetting?.id }))
      .then(() => {
        if (deleteSetting.isDefault) {
          dispatch(fetchuserSet({ customer_id, user_id }));
        } else {
          let filterMetricSettingList = userMetricSetting.data.filter(
            (ele) => ele.id != deleteSetting.id
          );

          dispatch({ type: SET_USERSET, payload: filterMetricSettingList });
        }
      })
      .catch((err) => {
        console.log(`Fail to Delete Metric Setting`, err.message);
      });
  }
  return (
    <div
      className="bodycontentWithoutScroll"
      style={{ display: "flex", flexDirection: "column" }}
    >
      <ToastContainer />
      {/* modal of metric add,update */}
      <Modal
        title={updateMetric?.id ? `Update Template` : `Add Template`}
        children={AddSet({
          handleCloseModal,
          sideTabOptions,
          handleSave,
          updateMetric: updateMetric,
          customIndexScoreTypes,
          open: isModalOpen,
        })}
        open={isModalOpen}
        handleClose={handleCloseModal}
        confirmBtnText="Add"
      ></Modal>

      {/* modal for add, edit sentiment question , brand piller */}
      <Modal
        title={
          updateAttribute
            ? ` Update ${upperCaseConverter(key)}`
            : `Add ${upperCaseConverter(key)}`
        }
        children={AddEditAttribute({
          handleCloseModal: handleCloseAddModal,
          sideTabOptions,
          selectedTab,
          handleSave: handleAttributeSave,
          selectedSideTab,
          updateAttribute: updateAttribute,
          hasCustomIndexScoreTypes: hasCustomIndexScoreTypesFeature,
          open: showAddModal,
        })}
        open={showAddModal}
        handleClose={handleCloseAddModal}
        updateAttribute={updateAttribute}
        confirmBtnText="Add"
      ></Modal>

      {/* Share Template modal — generic ShareModal, configured for the template domain */}
      <ShareModal
        open={shareModalOpen}
        onClose={() => {
          setShareModalOpen(false);
          setShareTarget(null);
        }}
        item={shareTarget}
        itemTypeLabel="template"
        shareEndpoint={SHARE_TEMPLATE_ENDPOINT}
        buildPayload={buildTemplateSharePayload}
      />

      <Header
        actionBtnVariant="contained"
        actionText={`Add Metric`}
        title="Template Settings"
        onActionClick={handleOpenModal}
        secondActionText={`Add ${selectedTab}`}
        secondActionClick={() => {
          setShowAddModal(true);
        }}
      />
      {/* Top navigation */}
      <div style={{ width: '100%', display: 'flex' }}>
        <div style={{ width: '25%' }}></div>
        <HeaderTabRender
          options={visibleTabOptions}
          selected={selectedMainTab}
          onChange={(mainTab) => {
            setSelectedMainTab(mainTab);
            // Auto-select first sub-template when switching main tabs
            const tabOption = TAB_OPTIONS.find(opt => opt.value === mainTab);
            if (tabOption?.subTemplates && tabOption.subTemplates.length > 0) {
              setSelectedTab(tabOption.subTemplates[0].value);
            } else {
              setSelectedTab(mainTab);
            }
          }}
        />
      </div>

      <hr />
      <div className={classes.second_section}>
        {/*Add setting*/}

        <TabRender
          options={sideTabOptions}
          selected={selectedSideTab}
          onChange={(tab) =>
            dispatch({ type: "SET_METRICE_SETTING_ID", payload: tab })
          }
          customClass={classes.vertical_tab}
          handleMetricSettingDelete={handleMetricSettingDelete}
          onClickEditClick={(option) => {
            setModalOpen(true);
            setUpdateMetric(option);
          }}
          setDefaultIconClick={setDefault}
          handleOpenModal={handleOpenModal}
          onShareClick={handleShareClick}
          isSharingEnabled={!!user?.is_sharing_enabled}
        />

        {userMetricSetting?.loading ? (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              height: "30%",
              alignItems: "center",
            }}
          >
            <Spinner />
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "75%",
              height: "100%",
            }}
          >
            {/* Sub-template selection */}
            {TAB_OPTIONS.find(opt => opt.value === selectedMainTab)?.subTemplates && (
              <div style={{ display: 'flex', paddingBottom: '10px', paddingTop: '5px' }}>
                <SubTemplateSelector
                  subTemplates={TAB_OPTIONS.find(opt => opt.value === selectedMainTab).subTemplates}
                  selected={selectedTab}
                  onChange={(subTab) => {
                    setSelectedTab(subTab);
                  }}
                />
              </div>
            )}
            <div className={classes.centerAlign}>
              <h4 className={`${classes.title} `}>{`${upperCaseConverter(
                sideTabName
              )}: ${upperCaseConverter(key)}s`}</h4>
              {selectedSideTab != DefaultSet && <MUIButton
                data-html2canvas-ignore
                variant={"outlined"}
                onClick={() => {
                  let tabData = userMetricSetting?.data?.find((ele) => ele.id == selectedSideTab) ?? {};
                  let length = tabData?.[selectedTab]?.length ?? null;
                  let maxCount =
                    selectedTab === "visibility" && hasCustomIndexScoreTypesFeature
                      ? 20
                      : requiredCount?.[selectedTab]?.maxCount;

                  if (length && maxCount && length >= (maxCount)) {
                    return toast.warn(`You can only add ${length} ${TitleName[selectedTab]}. Please remove the existing one before adding a new ${TitleName[selectedTab]}.`)
                  }
                  setShowAddModal(true);
                }}
                className={classes.setButton}
              >
                {`Add ${key}`}
              </MUIButton>
              }
            </div>


            <Sentiment
              setModalOpen={setModalOpen}
              selectedSideTab={selectedSideTab}
              editIconClick={editIconClick}
              selectedTab={selectedTab}
            />
          </div>
        )}
      </div>
    </div>
  );
}

function SubTemplateSelector({ subTemplates, selected, onChange }) {
  return (
    <FormControl component="fieldset">
      <RadioGroup
        row
        value={selected}
        onChange={(e) => onChange(e.target.value)}
      >
        {subTemplates.map((subTemplate) => (
          <FormControlLabel
            key={subTemplate.value}
            value={subTemplate.value}
            control={<Radio />}
            label={subTemplate.name}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
}

function HeaderTabRender({ options, selected, onChange, customClass }) {
  return (
    <nav className="customTabs" style={{ backgroundColor: 'transparent', marginTop: '5px' }}>
      <div
        className={`nav nav-tabs  ${classes.tabClass} ${customClass}`}
        id="nav-tab"
        role="tablist"
        sty
      >
        {options.map((option) => {
          return (
            <button
              key={option.value}
              onClick={() => {
                onChange(option.value);
              }}
              className={` ${classes.buttonClass} 
                ${selected === option.value ? classes.active : ""
                }
                `}
              id="nav-overview-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-overview"
              type="button"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true"
            >
              {option.name}
            </button>
          );
        })}
      </div>
    </nav>
  );
}

const statusColors = {
  COMPLETED: "green",
  RETRY: "red",
  DEFAULT: "#FCD34D",
};

function TabRender({
  options,
  selected,
  onChange,
  handleMetricSettingDelete,
  onClickEditClick,
  setDefaultIconClick,
  handleOpenModal,
  onShareClick,
  isSharingEnabled,
}) {
  let [showModal, setShowModal] = useState(false);
  let [deleteSetting, setDeletedSetting] = useState(null);
  let [showMessageModal, setShowMessageModal] = useState(false);

  const { data } = useSelector((store) => store.userSet);

  function handleDefaultClick(option) {
    /*selected template is  standard template and  standard template is also default Template we click on checkbox  to deselect it*/
    /*check condition of stand template*/
    if (option.value === DefaultSet && option.isDefault) {
      setShowMessageModal(true);
    } else {
      /*uncheck condition of standard template*/
      setDefaultIconClick({
        id: option.id,
        name: option.name,
        isDefault: !option.isDefault,
      });
    }
  }
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "25%",
      }}
    >
      <MUIButton
        data-html2canvas-ignore
        variant={"outlined"}
        // startIcon={actionIcon ? actionIcon : null}
        onClick={handleOpenModal}
        className={classes.setButton}
      >
        {"Add Template"}
      </MUIButton>
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          overflowX: "hidden",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            backgroundColor: "#eff4f8",
            width: "100%",
            // height: "100%",
            // border: `1px solid #c9cccc`,
            height: "100%",
            borderRadius: "4px",
            padding: "8px",
          }}
        >
          <ConfirmModal
            show={showModal}
            handleConfirmDeletion={() => {
              setShowModal(false);
              handleMetricSettingDelete(deleteSetting);
            }}
            selectedId={deleteSetting}
            handleClose={() => {
              setDeletedSetting(null);
              setShowModal(false);
            }}
            message={`Are you sure you want to delete this template- ${deleteSetting?.name ?? ""
              } ?`}
            title="Confirm Template Deletion"
          />
          <MessageModal
            show={showMessageModal}
            handleClose={() => {
              setShowMessageModal(false);
            }}
            title={`Can't Deselect Standard Template`}
            message={
              "The selected template is marked as your default template. To deselect it, please set another template as default first."
            }
          />

          {options.map((option) => {
            return (
              <div
                className={classes.sideTabContainer}
                style={{
                  border: `1px solid #c9cccc`,
                  borderLeft: `4px solid ${statusColors.COMPLETED}`,
                  backgroundColor:
                    option.value == selected ? "#cee0f2" : "#eff4f8",
                  borderRadius: "5px",
                  flexShrink: 0,
                }}
                key={option.value}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  onChange(option.value);
                }}
              >
                <div className={classes.text_container}>
                  <span title={option.name} className={classes.text}>
                    {upperCaseConverter(option.name)}
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div className={classes.actionContainer}>
                    <Tooltip title="Set As Default">
                      <Checkbox
                        checked={option?.isDefault ?? false}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDefaultClick(option);
                        }}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    </Tooltip>
                    {option.value !== "default" && (
                      <>
                        <Tooltip title="Edit">
                          <MUIIconButton
                            sx={{ color: "#000" }}
                            onClick={(e) => {
                              e.stopPropagation(); // stops parent click handlers
                              onClickEditClick(option);
                            }}
                          >
                            <EditOutlinedIcon />
                          </MUIIconButton>
                        </Tooltip>

                        <Tooltip title="Delete">
                          <MUIIconButton
                            sx={{ color: "#000" }}
                            onClick={(e) => {
                              e.stopPropagation(); // stops parent click handlers
                              e.preventDefault();
                              setShowModal(true);
                              setDeletedSetting(option);
                            }}
                          >
                            <DeleteOutlineOutlinedIcon />
                          </MUIIconButton>
                        </Tooltip>

                        {isSharingEnabled && (
                          <Tooltip title="Share template to another user">
                            <MUIIconButton
                              sx={{ color: "#000" }}
                              onClick={(e) => {
                                e.stopPropagation(); // stops parent click handlers
                                e.preventDefault();
                                onShareClick(option);
                              }}
                            >
                              <ShareOutlinedIcon />
                            </MUIIconButton>
                          </Tooltip>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
